import React from "react";
import Images from "../../../asset/Images";

const QuotationFooter = ({ content }) => {
  const normalizedContent = (content || "").toLowerCase().trim();



  const isRashiSpaceSolution =
    normalizedContent === "Rashi Space Solution" ||
    normalizedContent === "Rashi space solution" ||
    normalizedContent === "rashi space solution"; // optional: you can handle other variants here

  return (
    <>
      {isRashiSpaceSolution ? (
        <div className="quotation_logo_block">
          <img
            // src={Images?.rasispace}
            src={Images?.rasispacefooter}
            alt="no-image"
            style={{ width: "100%", height: "100%", objectFit: "fill" }}
          />
        </div>
      ) : (
        <div className="quotation_logo_block">
          <img
            src={Images?.srilakshmi}
            alt="no-image"
            style={{ width: "100%", height: "100%", objectFit: "fill" }}
          />
        </div>
      )}
    </>
  );
};

export default QuotationFooter;
